export default function AppIcon({ src, name, size = 56 }) {
  const radius = Math.round(size * 0.2237);
  const style = {
    width: size,
    height: size,
    objectFit: "cover",
    flexShrink: 0,
    borderRadius: radius,
  };
  if (src) {
    return <img src={src} alt={name || ""} width={size} height={size} style={style} />;
  }
  const letter = String(name || "A").trim().charAt(0).toUpperCase() || "A";
  return (
    <div
      className="bg-light text-muted d-flex align-items-center justify-content-center fw-semibold"
      style={{ ...style, fontSize: Math.max(14, size / 3) }}
      aria-hidden="true"
    >
      {letter}
    </div>
  );
}
